// Use the @Injectable decorator for your Constants class
import { Injectable } from '@angular/core';
import { TranslateService } from '../translate';
@Injectable()
export class Constants {
	domainUrl: string;
	baseUrl: string;
	baseAuthUrl: string;
	pageLength: any;
	isCompany: boolean;
	dateFormat: string;
	dateTimeFormat: string;
	menuList: any;
	currentDomainName: any = "";
	standardTimeZone: string = "UTC";
	graphDefaultRecordDisplayLimit = "15"
	employeeTypeList = ['AdminManager', 'Manager'];
	statusList = [
		{ id: '1', name: 'Active' },
		{ id: '0', name: 'Inactive' }
	];
	isClerk = [
		{ id: '1', name: 'Yes' },
		{ id: '0', name: 'No' }
	];
	ConsumableOptions = [
		{ id: 'Yes', name: 'Yes' },
		{ id: 'No', name: 'No' }
	];
	orderStatusList = [
		{ title: 'Out', value: 'out' },
		{ title: 'Return', value: 'returned' },
		{ title: 'Return-Defect', value: 'damaged' },
		{ title: 'Return-Disposal', value: 'disposal' },
	];
	checklistStatusList = [
		{ title: 'Pass', value: 'Pass' },
		{ title: 'Fail', value: 'Fail' },
	];
	payrollStatusList = [
		{ title: 'Ordered', value: 'ordered' },
		{ title: 'Picked Up', value: 'pickedup' },
		{ title: 'Refund ', value: 'refund' },
	];
	loanerStatusList = [
		{ title: 'Out', value: 'out' },
		{ title: 'Return', value: 'returned' },
		{ title: 'Return-Defect', value: 'damaged' },
		{ title: 'Return-Disposal', value: 'disposal' },
		{ title: 'Return-Lost', value: 'lost' },
	];
	co2StatusList = [
		{ title: 'At Facility', value: 'out' },
		{ title: 'Returned', value: 'returned' },
		{ title: 'Other', value: 'non-returnable' },
	];
	shiftStatus = [
		{ title: 'Shift1', id: 'Shift1' },
		{ title: 'Shift2', id: 'Shift2' },
		{ title: 'Shift3', id: 'Shift3' },
	];
	transactionTypeList = [
		{ title: 'Employee Transactions', id: 'employee_transaction' },
		{ title: 'Foreign Materials', id: 'hazard_items' },
		{ title: 'Loaner Items', id: 'loaner_items' },
		{ title: 'Payroll', id: 'payroll_items' },
		{ title: 'Inventory Adjustment', id: 'inventory_adjustment' },
		{ title: 'Sharpenings', id: 'sharpening' },
		{ title: 'Injections', id: 'injection' },
	];
	employeeFilterList = [
		{ title: 'Employee ID', id: 'filter_employee_username' },
		{ title: 'Employee Name', id: 'filter_employee_name' },
		{ title: 'JobZone', id: 'filter_jobzone' },
		{ title: 'Knife Number', id: 'filter_knife_number' },
		{ title: 'Location', id: 'filter_location' },
		{ title: 'Zone', id: 'filter_zone_name' },
		{ title: 'Confirm Signature', id: 'filter_confirm_signature' },
		{ title: 'Clerk Name', id: 'filter_clerk_name' },
		{ title: 'Charge Signature', id: 'filter_charge_signature' },
	];
	productFilterList = [
		{ title: 'Product Title', id: 'filter_product_title' },
		{ title: 'QTY', id: 'filter_product_qty' }
	];
	orderStatusListOnlyInOut = [
		{ title: 'Out', value: 'out' },
		{ title: 'In', value: 'in' }
	];
	orderStatusInOut = [
		{ title: 'Out', value: 'out' },
		{ title: 'In', value: 'in' },
		{ title: 'N/A', value: 'n/a' },
	];
	ispReportStatusList = [
		{ title: 'Out', value: 'Out' },
		{ title: 'Return', value: 'In' }
	];
	foreignMaterialStatusList = [
		{ title: 'Hazard In/Out', value: 'hazard_items' },
		{ title: 'Hazard In', value: 'In' },
		{ title: 'Hazard Out', value: 'Out' },
		{ title: 'Hazard Lost', value: 'Lost' },
	];
	orderStatusListOnlyIssueReceive = [
		{ title: 'Issue', value: 'out' },
		{ title: 'Receive', value: 'in' }
	];
	expirationStatusList = [
		{ title: 'Expired', value: 'Expired' },
		{ title: 'Not Expired', value: 'Not Expired' },
		{ title: 'Removed', value: 'Removed' },
	];
	safetyIncidentStatusList = [
		{ title: 'Expired', value: 'Expired' },
		{ title: 'Not Completed', value: 'Not Completed' },
		{ title: 'Completed', value: 'Completed' },
	];
	graphRecordDisplayLimitList = [
		{ title: 'Top 5', value: '5' },
		{ title: 'Top 10', value: '10' },
		{ title: 'Top 15', value: '15' },
		{ title: 'Top 20', value: '20' },
		{ title: 'Top 25', value: '25' },
		{ title: 'Top 50', value: '50' },
		{ title: 'Top 75', value: '75' },
		{ title: 'Top 100', value: '100' },
		{ title: 'All', value: '' },
	];
	equipmentGroupViewByList = [
		{ title: 'Top 5', value: '5' },
		{ title: 'Top 10', value: '10' },
		{ title: 'Top 15', value: '15' },
		{ title: 'Top 20', value: '20' },
		{ title: 'Top 25', value: '25' },
		{ title: 'All', value: '' },
	];
	equipList = [
		{ title: 'Top 5', value: '5' },
		{ title: 'Top 10', value: '10' },
		{ title: 'Top 15', value: '15' },
		{ title: 'Top 20', value: '20' },
		{ title: 'Top 25', value: '25' },
		{ title: 'All', value: '' },
	];
	yearList = [
		{ id: '2015', name: '2015' },
		{ id: '2016', name: '2016' },
		{ id: '2017', name: '2017' }
	];
	truckzoneContentList = [
		{ title: 'Fresh', value: 'Fresh' },
		{ title: 'Frozen', value: 'Frozen' },
		{ title: 'Empty', value: 'Empty' }
	];
	truckzoneStatusList = [
		{ title: 'Inbound', value: 'Inbound' },
		{ title: 'Outbound', value: 'Outbound' }
	];
	constructor(private _translate: TranslateService) {
		this.domainUrl = window.location.origin;
		this.baseUrl = window.location.origin + '/siteapi';
		this.baseAuthUrl = window.location.origin + '/siteauthapi';
		this.pageLength = [10, 20, 50];
		this.dateFormat = 'MM/DD/YYYY';
		this.dateTimeFormat = 'MM/DD/YYYY HH:mm:ss';
		/* Flag: is company or not */
		var urlpart = this.domainUrl.split('.');
		// Get current domain name
		if (urlpart) {
			var splitfordomain = urlpart[0].split('//');
			if (splitfordomain.length >= 2) {
				this.currentDomainName = splitfordomain[1];
			}
		}
		if (urlpart[1] == "local" || urlpart[2] == "local") {
			if (this.domainUrl.split('.').length == 2) {
				this.isCompany = false;
			} else {
				this.isCompany = true;
			}
		} else {
			if (this.domainUrl == "http://innovazone.softwebopensource.com" || this.domainUrl == "http://izplatforms.com") {
				this.isCompany = false;
			} else {
				this.isCompany = true;
			}
		}
		this.isCompany = true;
		this.selectLang('en');
	}
	isCurrentLang(lang: string) {
		return lang === this._translate.currentLang;
	}
	selectLang(lang: string) {
		// set default;
		this._translate.use(lang);
	}
	/**
	 * @author Ghanshyam Tank < ghanshyam.tank@softwebsolutions.com >
	 * @uses Datatables No. columns autoincreament value set form this function
	 * @return integer
	 */
	dataTableNo(dataTable, iDisplayIndex) {
		var pageinfo = dataTable.page.info();
		var currentpage = (pageinfo.page) * pageinfo.length;
		var display_number = (iDisplayIndex + 1) + currentpage;
		return display_number;
	}
	/**
	 * @author Ghanshyam Tank < ghanshyam.tank@softwebsolutions.com >
	 * @uses Datatables No. columns autoincreament value set form this function
	 * @return integer
	 */
	numberPrefix(str, max) {
		if (str) {
			str = str.toString();
			return str.length < max ? this.numberPrefix("0" + str, max) : str;
		} else {
			return '';
		}
	}
	/**
	 * @author Ghanshyam Tank < ghanshyam.tank@softwebsolutions.com >
	 * @uses Datatables No. columns autoincreament value set form this function
	 * @return integer
	 */
	monthAsString(monthNumber) {
		var monthName = '';
		if (monthNumber == '01') {
			monthName = 'January';
		}
		if (monthNumber == '02') {
			monthName = 'February';
		}
		if (monthNumber == '03') {
			monthName = 'March';
		}
		if (monthNumber == '04') {
			monthName = 'April';
		}
		if (monthNumber == '05') {
			monthName = 'May';
		}
		if (monthNumber == '06') {
			monthName = 'June';
		}
		if (monthNumber == '07') {
			monthName = 'July';
		}
		if (monthNumber == '08') {
			monthName = 'August';
		}
		if (monthNumber == '09') {
			monthName = 'September';
		}
		if (monthNumber == '10') {
			monthName = 'October';
		}
		if (monthNumber == '11') {
			monthName = 'November';
		}
		if (monthNumber == '12') {
			monthName = 'December';
		}
		return monthName;
	}
	weekAsString(weekNumber) {
		var weekName = '';
		if (weekNumber == '0') {
			weekName = 'Week 1';
		}
		if (weekNumber == '1') {
			weekName = 'Week 2';
		}
		if (weekNumber == '2') {
			weekName = 'Week 3';
		}
		if (weekNumber == '3') {
			weekName = 'Week 4';
		}
		if (weekNumber == '4') {
			weekName = 'Week 5';
		}
		if (weekNumber == '5') {
			weekName = 'Week 6';
		}
		return weekName;
	}
	weekAsNumber(weekName) {
		var weekNumber = '';
		if (weekName == 'Week 1') {
			weekNumber = '0';
		}
		if (weekName == 'Week 2') {
			weekNumber = '1';
		}
		if (weekName == 'Week 3') {
			weekNumber = '2';
		}
		if (weekName == 'Week 4') {
			weekNumber = '3';
		}
		if (weekName == 'Week 5') {
			weekNumber = '4';
		}
		if (weekName == 'Week 6') {
			weekNumber = '5';
		}
		return weekNumber;
	}
	/**
	 * @author Ghanshyam Tank < ghanshyam.tank@softwebsolutions.com >
	 * @uses Datatables No. columns autoincreament value set form this function
	 * @return integer
	 */
	monthAsNumber(monthName) {
		var monthNumber = '';
		if (monthName == 'January') {
			monthNumber = '01';
		}
		if (monthName == 'February') {
			monthNumber = '02';
		}
		if (monthName == 'March') {
			monthNumber = '03';
		}
		if (monthName == 'April') {
			monthNumber = '04';
		}
		if (monthName == 'May') {
			monthNumber = '05';
		}
		if (monthName == 'June') {
			monthNumber = '06';
		}
		if (monthName == 'July') {
			monthNumber = '07';
		}
		if (monthName == 'August') {
			monthNumber = '08';
		}
		if (monthName == 'September') {
			monthNumber = '09';
		}
		if (monthName == 'October') {
			monthNumber = '10';
		}
		if (monthName == 'November') {
			monthNumber = '11';
		}
		if (monthName == 'December') {
			monthNumber = '12';
		}
		return monthNumber;
	}
	/**
	 * @author Ghanshyam Tank < ghanshyam.tank@softwebsolutions.com >
	 * @uses Datatables No. columns autoincreament value set form this function
	 * @return integer
	 */
	reportEmployeeData(aData) {
		var img_str = '';
		if (aData.product_image != '') {
			img_str = ' <div class="product_image"> <img src="' + aData.employee_img_url + '" onerror="this.onerror=null;this.src=\'/../uploads/no_image.jpg\';" width="50" height="50"/> </div> ';
		} else {
			img_str = ' <div class="product_image"> <img src="../uploads/no_image.jpg" width="50" height="50"/> </div> ';
		}
		var employeeDetail = '<div class="product_image"> ' + img_str + ' </div>';
		employeeDetail += '<div class="product_main_div">';
		employeeDetail += '<div class="product_title_div margin-bottom-report">' + aData.employee_name + '</div>';
		employeeDetail += '<div class="category_div margin-bottom-report">' + aData.job_title + '</div>';
		employeeDetail += '<div class="margin-bottom-report">';
		employeeDetail += '<div class="report_barcode">';
		employeeDetail += '<div class="float_l"><img title="Location#" src="../themes/sitetheme/images/report/report_location.png" width="15"></div>';
		employeeDetail += '<div class="float_l w80 icon_display_text" title="Location#">' + aData.order_location + '</div>';
		employeeDetail += '</div>';
		employeeDetail += '<div class="report_department">';
		employeeDetail += '<div class="float_l"><img title="Department#" src="../themes/sitetheme/images/report/report_department.png" width="15"></div>';
		employeeDetail += '<div class="float_l w80 icon_display_text" title="Department#">' + aData.order_department_no + '</div>';
		employeeDetail += '</div>';
		employeeDetail += '<div style="clear:both;"></div>';
		employeeDetail += '</div>';
		employeeDetail += '<div class="margin-bottom-report">';
		employeeDetail += '<div class="report_barcode">';
		employeeDetail += '';
		employeeDetail += '<div class="float_l w80 icon_display_text" title="Username#">' + aData.employee_username + '</div>';
		employeeDetail += '</div>';
		employeeDetail += '<div style="clear:both;"></div>';
		employeeDetail += '</div>';
		return employeeDetail;
	}

	/**
	 * @uses Datatables firegighter name display
	 * @return 
	 */
	reportFireFighterData(aData) {

		var employeeDetail = '<div class="product_main_div">';
		employeeDetail += '<div class="product_title_div margin-bottom-report">' + aData.employee_name + '</div>';
		employeeDetail += '<div class="category_div margin-bottom-report">' + aData.email + '</div>';
		employeeDetail += '<div style="clear:both;"></div>';
		employeeDetail += '</div>';
		return employeeDetail;
	}
	/**
	 * @author Ghanshyam Tank < ghanshyam.tank@softwebsolutions.com >
	 * @uses return current date with time
	 * @return datetime
	 */
	formatDate(dateValue, today = '') {
		if (dateValue != '') {
			var date = new Date(dateValue);
		} else {
			var date = new Date();
		}
		var fullyear = date.getFullYear(),
			month = date.getMonth() + 1,
			fullMonth = month < 10 ? "0" + month : month,
			day = date.getDate(),
			fullDate = day < 10 ? "0" + day : day,
			hour = date.getHours(),
			minute = date.getMinutes(),
			second = date.getSeconds(),
			hourFormatted = hour % 12 || 12, // hour returned in 24 hour format
			minuteFormatted = minute < 10 ? "0" + minute : minute,
			morning = hour < 12 ? "AM" : "PM";
		var hourFormat = hour < 10 ? "0" + hour : hour,
			minuteFormat = minute < 10 ? "0" + minute : minute,
			secondFormat = second < 10 ? "0" + second : second;
		if (today == 'date') {
			return fullMonth + "/" + fullDate + "/" + fullyear + " " + "00:00:00";
		} else if (today == 'datetime') {
			return fullMonth + "/" + fullDate + "/" + fullyear + " " + hourFormat + ":" +
				minuteFormat + ':' + secondFormat;
		} else {
			return fullMonth + "/" + fullDate + "/" + fullyear + " " + hourFormatted + ":" +
				minuteFormatted + ' ' + morning;
		}
	}
	reportKeyList = {

		LABEL_FOR_TOOLS: '# Tools',
		LABEL_FOR_AVG_DAYS: 'Average # Days',
		LABEL_FOR_AVG_SHARPENINGS: 'Average # Sharpenings',
		LABEL_FOR_EMPLOYEE: 'Employee',
		LABEL_FOR_FIREFIGHTER: 'FireFighter Name',
		LABEL_FOR_CHECKLISTTYPE: 'Checklist Type',
		LABEL_FOR_CUSTOMER: 'Customer',
		LABEL_FOR_CUSTOMER_ASSETNUMBER: 'Asset#',
		LABEL_FOR_CUSTOMER_ASSET: 'Asset',
		LABEL_FOR_INJECTED_DATE: 'Injected Date',
		INOUT_RETURNED_QTY: 'Asset',
		LABEL_FOR_PRODUCT_VALUE: 'Product Value',
		LABEL_FOR_PRODUCT_TITLE: 'Product Name',
		LABEL_FOR_PR_DESCRIPTION: 'Product Description',
		HOOP_ID: 'Hoop ID',
		LABEL_FOR_PRODUCT: 'Product',
		LABEL_FOR_QTY: 'Qty',
		LABEL_FOR_IN_OUT: 'In/Out',
		LABEL_FOR_DATE_TIME: 'Date & Time',
		LABEL_FOR_ISS_RTN: 'ISS / REC',
		LABEL_FOR_PART_NO: 'Part#',
		LABEL_FOR_QUANTITY: 'Quantity',
		LABEL_FOR_QUANTITY_OR_RETURNED_QUANTITY: 'Qty/Return Qty',
		LABEL_FOR_CHARGE_SIGNATURE: 'Charge Signature',
		LABEL_FOR_ZONE_NAME: 'Zone',
		LABEL_FOR_UOM: 'UOM',
		LABEL_FOR_CC_NO: 'CC#',
		LABEL_FOR_PRM_SUB: 'PRM / SUB',
		LABEL_FOR_EQUIP_WORK: 'Equip# / Work#',
		LABEL_FOR_TASK: 'Task',
		LABEL_FOR_DEPARTMENT_NO: 'Department#',
		LABEL_FOR_UNIT_PRICE: 'Unit Price',
		LABEL_FOR_TOTAL_PRICE: 'Total Price',
		LABEL_FOR_SIGNATURE: 'Signature',
		LABEL_FOR_RECEIPT: 'Receipt',
		LABEL_FOR_LOCATION: 'Location',
		LABEL_FOR_EQUPMENT_ASSET_NO: 'Equipment / Asset#',
		LABEL_FOR_EQUPMENT_NO: 'Equipment #',
		WORK_ORDER_NO: 'Work Order#',
		LABEL_FOR_INOUT_TIME: 'In/Out Time',
		LABEL_FOR_BIN_LOC: 'Bin Loc.',
		LABEL_FOR_STATUS: 'Status',
		LABEL_FOR_DATE_TIME_OUT: 'Date Time-OUT',
		LABEL_FOR_QTY_IN: 'Quantity In',
		LABEL_FOR_QTY_OUT: 'Quantity Out',
		LABEL_FOR_DATE_TIME_IN: 'Date Time-IN',
		LABEL_FOR_APPROVE_OUT: 'Approve Out',
		LABEL_FOR_EMPLOYEE_NAME: 'Employee Name',
		LABEL_FOR_TRUCK_NO: 'Truck No',
		LABEL_FOR_DATE_OUT_TIME: 'Out Time',
		LABEL_FOR_DATE_IN_TIME: 'In Time',
		LABEL_FOR_DATE_ROUTE_NO: 'Route No',
		LABEL_FOR_CLERK_NAME: 'Clerk Name',
		LABEL_FOR_CLERK_NAME_ID: 'Clerk Name & ID',
		LABEL_FOR_NO_OF_TRANSACTIONS: 'No Of Transactions',
		LABEL_FOR_ROUTE_NO: 'Route #',
		LABEL_FOR_DRIVER_NAME: 'Driver Name',
		LABEL_FOR_START_TIME: 'Start Time',
		LABEL_FOR_START_DATE: 'Start Date',
		LABEL_FOR_DAYS: 'Days',
		LABEL_FOR_SHARPENINGS: 'Sharpenings',
		LABEL_FOR_RETURN_REASON: 'Return Reason',
		LABEL_FOR_END_DATE: 'End Date',
		LABEL_FOR_BIGINING_MILEAGE: 'Biginning Mileage',
		LABEL_FOR_DRIVER_EMPLOYEE: 'Driver/Employee',
		LABEL_FOR_ROUTE_SEQUENCE: 'Route Sequence',
		LABEL_FOR_CUSTOMER_ID: 'Customer ID',
		LABEL_FOR_ADDRESS: 'Address',
		LABEL_FOR_PRODUCT_DESCRIPTION: 'Product / Description',
		LABEL_FOR_INVOICE_IMAGE: 'Invoice Image',
		LABEL_FOR_LOANER: 'Loaner',
		LABEL_FOR_JOBZONE: 'Job Zone',
		LABEL_FOR_PART: 'Part',
		LABEL_FOR_EQUIP_ASSET: 'Equip / Asset#',
		LABEL_FOR_UOM_BULK: 'UOM / BULK',
		LABEL_FOR_DESCRIPTION: 'Description',
		LABEL_FOR_TOTAL_QTY: 'Total Qty',
		LABEL_FOR_RETURNED_QTY: 'Returned Qty',
		LABEL_FOR_TOTAL_COST: 'Total Cost',
		LABEL_FOR_COST_CENTER: 'Cost Center',
		LABEL_FOR_LOCKER_NO: 'Locker#',
		LABEL_FOR_COMBINATION_NO: 'Combination#',
		LABEL_FOR_DESTINATION: 'Destination',
		LABEL_FOR_COMMENTS: 'Comments',
		LABEL_FOR_LOCATION_NO: 'Location No',
		LABEL_FOR_PRODUCT_CONVERSION: 'Product Conversation',
		LABEL_FOR_EQUIPMENT_NO: 'Equipment#',
		LABEL_FOR_ORDER_DATE: 'Order Date',
		LABEL_FOR_ASSET_NO: 'Asset#',
		LABEL_FOR_SUPERVISOR: 'Supervisor',
		LABEL_FOR_GARMENT_ID: 'Garment ID',
		LABEL_FOR_INSPECTOR: 'Inspector',
		//LABEL_FOR_GARMENT_ID_IN:'Garment ID - IN',
		LABEL_FOR_RETURN_COMMENT: 'Return Comment',
		LABEL_FOR_TOTAL_EXPENSE: 'Total Expense',
		LABEL_FOR_CONFIRM_SIGNATURE: 'Confirm Signature',
		LABEL_FOR_RENTAL_DATE: 'Rental/Set Date',
		LABEL_FOR_RELEASE_DATE: 'Release/End Date',
		LABEL_FOR_SIZE: 'Size',
		LABEL_FOR_MIN: 'Min',
		LABEL_FOR_MAX: 'Max',
		LABEL_FOR_MODEL_NO: 'Model#',
		LABEL_FOR_PICKUP_CHARGE: 'Delivery/Pick Up Charge',
		LABEL_FOR_PAYROLL_DEDUCTION: 'Payroll Deduction',
		LABEL_FOR_IS_TRACK: 'Track',
		LABEL_FOR_UNIT_COST: 'Unit Cost',
		LABEL_FOR_CHARGEBLE_COMMENT: 'Comment',
		LABEL_FOR_COMPLETED_COMMENT: 'Completed Comment',
		LABEL_FOR_QTY_IN_BIN: 'Qty In Bin',
		LABEL_FOR_PRODUCT_NO: 'Product#',
		LABEL_FOR_ISSUE_DATE_TIME: 'Issue Date & Time',
		LABEL_FOR_EXPIRATION_DATE: 'Expiration Date',
		LABEL_FOR_IMAGE: 'Images',
		LABEL_FOR_IMAGES: 'Image',
		LABEL_FOR_TRUCK_OUT_TIME: 'Truck Out',
		LABEL_FOR_TRUCK_IN_TIME: 'Truck In',
		LABEL_FOR_PRODUCT_NAME: 'Product Title',
		LABEL_FOR_SERIAL_NO: 'Serial Number',
		LABEL_FOR_TOTAL_QUANTITY_ISS_RTN: 'Total Quantity Issued/Returned',
		LABEL_FOR_VCR_CORRECT: 'VCR Correct',
		LABEL_FOR_VCR_NOT_CORRECT_REASON: 'VCR Not Correct Reason',
		LABEL_FOR_CHARGEABLE_COMMENT: 'Chargeable Comment',
		LABEL_FOR_ORDER_NO: 'Order #',
		LABEL_FOR_FARM: 'Farm',
		LABEL_FOR_DEPARTMENT: 'Department',
		LABEL_FOR_TOTAL_QTY_ISSUED: 'Total Qty Issued',
		LABEL_FOR_LAST_LOGIN: 'Last Login',
		LABEL_FOR_LAST_REPORT_VIEWED: 'Last Report Viewed',
		LABEL_FOR_TOTAL_LOGINS: 'Total Logins',
		LABEL_FOR_REPORTS_VIEWED: 'Reports Viewed',
		LABEL_FOR_REPORT_VIEWED: 'Report Viewed',
		LABEL_FOR_LOGIN_TIME: 'Login Time',
		LABEL_FOR_TOTAL_TIME: 'Total Time',
		LABEL_FOR_LINE_STATION: 'Line/Station',
		LABEL_FOR_TIME_OUT: 'Time Out',
		LABEL_FOR_AUDITOR: 'Auditor',
		LABEL_FOR_AUDIT_DATE: 'Audit Date',
		LABEL_FOR_AUDITS: '# Of Audits',
		LABEL_FOR_LINE_STATION_ID: 'Line/Station ID',
		LABEL_FOR_ASSET_ID_IN: 'Asset ID - IN',
		LABEL_FOR_DATE_OUT: 'Date OUT',
		LABEL_FOR_AUDITOR_NAME: 'Auditor Name',
		LABEL_FOR_DATE_IN: 'Date IN',
		LABEL_FOR_TIME_IN: 'Time IN',
		LABEL_FOR_TRX_CODE: 'Trx Code',
		LABEL_FOR_ZONE: 'Zone',
		LABEL_FOR_VENDOR: 'Vendor',
		LABEL_FOR_TRACTOR: 'Vehicle ID#',
		LABEL_FOR_TRAILER: 'Trailer ID#',
		LABEL_FOR_INBOUND_OUTBOUND: 'Inbound/Outbound',
		LABEL_FOR_MOVEMENT: 'Movement',
		LABEL_FOR_CONTENTS: 'Contents',
		LABEL_FOR_PO_BOL_LOAD: 'PO#/BOL#',
		LABEL_FOR_TRAILER_TEMPERATURE: 'Temperature',
		LABEL_FOR_TRAILER_TEMPERATURE_SET: 'Temp Set',
		LABEL_FOR_FUEL_LEVEL: 'Fuel Level',
		LABEL_FOR_WATCH_SEAL_INSPECTED: 'Lock Seal Inspected',
		LABEL_FOR_TRAILER_DAMAGE: 'Trailer Damage',
		LABEL_FOR_WATCH_SEAL_BOL: 'Seal#',
		LABEL_FOR_WATCH_SEAL_TRAILER: 'Load#',
		LABEL_FOR_VENT_SEAL: 'Vent Seal#',
		LABEL_FOR_WATCH_SEAL_TEMP: 'Seal Temp',
		LABEL_FOR_CARRIER: 'Carrier',
		LABEL_FOR_AREA: 'Area',
		LABEL_FOR_DATE: 'Date',
		LABEL_FOR_OUT: 'Out',
		LABEL_FOR_IN: 'In',
		LABEL_FOR_TOTAL_OUT: 'Total OUT',
		LABEL_FOR_TOTAL_IN: 'Total IN',
		LABEL_FOR_TRAILER_ID: 'Trailer #',
		LABEL_FOR_DATE_ISSUED: 'Date Issued',
		LABEL_FOR_TIME_ISSUED: 'Time Issued',
		LABEL_FOR_GARMENT_TYPE: 'Garment Type',
		LABEL_FOR_DATE_RETURNED: 'Date Returned',
		LABEL_FOR_TIME_RETURNED: 'Time Returned',
		LABEL_FOR_SHARPENED: 'Sharpened',
		LABEL_FOR_NOT_SHARPENED: 'Not Sharpened',
		LABEL_FOR_RETURNED: 'Returned',
		LABEL_FOR_REMOVE: 'Remove',
		LABEL_FOR_COMPLETED: 'Completed',
		LABEL_FOR_ATTRIBUTE: 'Attribute',
		LABEL_FOR_SLOC: 'SLOC',
		LABEL_FOR_EMPLOYEE_ID: 'Employee ID#',
		LABEL_FOR_CYCLE_COUNT_QTY: 'Cycle Count QTY',
		LABEL_FOR_CYCLE_COUNT_CREATE_DATE: 'Cycle Count Date/Time',
		LABEL_FOR_CYCLE_COUNT_CLERK_NAME: 'Cycle Count Clerk',
		LABEL_FOR_CYCLE_COUNT_RESET: 'Reset',
		LABEL_FOR_KNIFE_NO: 'Knife No',
		LABEL_FOR_COMPLETED_BY: 'Completed By',
		LABEL_FOR_COMPLETED_DATE: 'Date & Time Completed',
		LABEL_FOR_COMPLETED_IMAGE: 'Completed Images',
		LABEL_FOR_PICKUP: 'Confirm Pickup',
		LABEL_FOR_REFUND: 'Refund',
	};
	/**
	 * @author Milan Dadhaniya < milan.dadhaniya@softwebsolutions.com >
	 * @uses return number 
	 * @return number with comma format
	 */
	numberWithCommas(number) {
		if (number) {
			//  var parts = number.toString().split(".");
			//  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			//  return parts.join(".");
			var amount = parseFloat(number).toFixed(2);
			var formattedString = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			return formattedString;
		} else return 0;
	}
	/**
	 * @author Milan Dadhaniya < milan.dadhaniya@softwebsolutions.com >
	 * @uses return wrap string 
	 * @return string 
	 */
	wordwrap(str, width, spaceReplacer) {
		if (str && str != undefined) {
			if (String(str).length > width) {
				var p = width
				for (; p > 0 && str[p] != ' '; p--) {
				}
				if (p > 0) {
					var left = str.substring(0, p);
					var right = str.substring(p + 1);
					return left + spaceReplacer + this.wordwrap(right, width, spaceReplacer);
				}
			}
		}
		return str;
	}
	// Date Time Convert on given Timezone
	dateTimeZoneConverter(dateValue, format, timezone, standardTimeZone) {
		var date = (dateValue != '') ? new Date(dateValue) : new Date();
		var dateOption = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: timezone };
		var timeOption = { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: timezone };
		var dateOptionVal = date.toLocaleString('en-US', dateOption);
		var timeOptionVal = date.toLocaleString('en-GB', timeOption);
		var hm = timeOptionVal.substr(0, 5);
		if (format == 'date') {
			return dateOptionVal + " " + "00:00:00";
		} else if (format == 'datetime') {
			return dateOptionVal + " " + hm + ":59";
		} else {
			return dateOptionVal + " " + hm + ":59";
		}
	}


	getURLPath(url){
		const segments = url.split('/').filter(Boolean); // ['report', 'master-employee-report']
		const lastOne = segments.slice(-1); // Get last 1
		return lastOne; // "master-employee-report"

	}

	// Get Last 2 year date
	getLastDate() {
		var today = new Date();
		var lastDate = new Date(today.getFullYear(), today.getMonth() - 24, today.getDate());
	
		var month = (lastDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so add 1
		var day = lastDate.getDate().toString().padStart(2, '0');
		var year = lastDate.getFullYear();
	
		return month + '/' + day + '/' + year;
	  }

}